




// import React, { useState } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData, employeeId }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);

//   // Updated Data with URL paths for View/Download functionality
//   const payslipsData = [
//     { id: 1, month: 'December 2025', fileName: 'PAY_DEC_2025.pdf', size: '245 KB', url: '/payslips/sample.pdf' },
//     { id: 2, month: 'November 2025', fileName: 'PAY_NOV_2025.pdf', size: '242 KB', url: '/payslips/sample.pdf' },
//     { id: 3, month: 'October 2025', fileName: 'PAY_OCT_2025.pdf', size: '240 KB', url: '/payslips/sample.pdf' },
//   ];

//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.fullName || " ",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.fullName || "Nisha ",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };

//   const submitBank = (action) => {
//     if (!bankDetails.bankName || !bankDetails.accNumber) {
//       alert("Please fill in the required bank details.");
//       return;
//     }
//     alert(`${action} successful for ${bankDetails.bankName}`);
//   };

//   const handleFileUpload = (e) => {
//     setReimburseData(prev => ({ ...prev, attachment: e.target.files[0] }));
//   };

//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     switch (subView) {
//       case "Salary Information-payslip":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Salary Information & Payslips</h3>
//               {/* <div className="cyber-badge">PAYROLL_SECURE</div> */}
//             </div>

//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE</th>
//                     <th>MONTH</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {payslipsData.map((slip) => (
//                     <tr key={slip.id}>
//                       <td className="file-cell">
//                         <span className="file-icon">📄</span>
//                         <div className="file-info">
//                           <span className="file-name">{slip.fileName}</span>
//                           <span className="file-size">{slip.size}</span>
//                         </div>
//                       </td>
//                       <td className="month-cell">{slip.month}</td>
//                       <td>
//                         <a 
//                           href={slip.url} 
//                           download={slip.fileName} 
//                           className="table-action-btn download"
//                         >
//                           DOWNLOAD
//                         </a>
//                       </td>
//                       <td>
//                         <a 
//                           href={slip.url} 
//                           target="_blank" 
//                           rel="noreferrer" 
//                           className="table-action-btn view"
//                         >
//                           VIEW
//                         </a>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Reimburesemnt section":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>New Expense Claim</h3>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group locked"><label>Ticket</label><input className="form-input" value={reimburseData.ticketNum} readOnly /></div>
//                 <div className="form-group locked"><label>Employee</label><input className="form-input" value={userData?.fullName} readOnly /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Amount (₹)</label><input name="amount" type="number" className="form-input" onChange={handleInputChange} required /></div>
//                 <div className="form-group locked"><label>Dept</label><input className="form-input" value={userData?.dept} readOnly /></div>
//               </div>
//               <div className="form-group">
//                 <label>Receipt Attachment</label>
//                 <div className="file-upload-wrapper">
//                   <input type="file" id="file-upload" className="file-input-hidden" onChange={handleFileUpload} />
//                   <label htmlFor="file-upload" className="file-upload-label">
//                     {reimburseData.attachment ? reimburseData.attachment.name : "Click to Upload Receipt"}
//                   </label>
//                 </div>
//               </div>
//               <button className="submit-leave-btn" onClick={() => alert("Reimbursement Submitted")}>SUBMIT CLAIM</button>
//             </form>
//           </div>
//         );

//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <div className="card-header-flex">
//                   <h3>Salary & Tax Calculator</h3>
//                   {/* <div className="cyber-badge">FY_2024-25</div> */}
//                 </div>
//                 <div className="leave-form">
//                   <div className="form-group">
//                     <label>Annual Gross CTC (₹)</label>
//                     <input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} />
//                   </div>
//                   <div className="button-group-cyber" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                     <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                     {result && (
//                       <button className="submit-leave-btn reset-style" style={{ width: '100%' }} onClick={() => setResult(null)}>
//                         RESET ANALYSIS
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg" style={{ color: '#ff4d4d' }}>- ₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Net (Take Home)</span><span className="res-value pos" style={{ color: '#00e676' }}>₹ {result.monthlyPay}</span></div>
//                     <div className="res-item"><span className="res-label">Annual Net</span><span className="res-value">₹ {result.annualPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">📡<p>Awaiting CTC Input...</p></div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bonus & incentives":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bonus & Incentives</h3>
//             <div className="bonus-summary-grid">
//               <div className="summary-item glass border-earned"><span>Total YTD</span><strong>₹ 50,000</strong></div>
//               <div className="summary-item glass border-sick"><span>Pending</span><strong>₹ 0.00</strong></div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Bank Account Information</h3>
//               {/* <div className="cyber-badge">FINANCE_CORE</div> */}
//             </div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Bank Name</label>
//                   <input type="text" name="bankName" placeholder="e.g. HDFC Bank" className="form-input" value={bankDetails.bankName} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Account Holder's Name</label>
//                   <input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Account Number</label><input type="password" name="accNumber" className="form-input" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Branch Name</label><input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} /></div>
//                 <div className="form-group">
//                   <label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="bank-actions-row">
//                 <button className="submit-leave-btn" onClick={() => submitBank('Submission')}>SUBMIT</button>
//                 <button className="submit-leave-btn update-style" onClick={() => submitBank('Update')}>UPDATE</button>
//                 <button className="submit-leave-btn clear-style" onClick={clearBankForm}>CLEAR</button>
//               </div>
//             </form>
//           </div>
//         );

//       case "Form 16 Download":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE</th>
//                     <th>FINANCIAL YEAR</th>
//                     <th>DOWNLOAD</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                    <tr>
//                     <td className="file-cell">📄 Form16_FY24-25.pdf</td>
//                     <td>2024-2025</td>
//                     <td><a href="/sample.pdf" download className="table-action-btn download">DOWNLOAD</a></td>
//                    </tr>
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Content coming soon.</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           "Reimburesemnt section",
//           "Bonus & incentives",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//             style={{ fontSize: '0.8rem', padding: '10px 5px' }}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;















// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData, employeeId }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);

//   // --- DATABASE STATES ---
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   // Base URL for your uploaded files on the PHP server
//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   // --- FETCH DOCUMENTS FROM REAL DATABASE ---
//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // Helper for formatting upload dates
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // --- BANK & REIMBURSEMENT STATE ---
//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.fullName || " ",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   // --- HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     switch (subView) {
//       case "Salary Information-payslip":
//         // Filter: Show only "Monthly Salary Slip" in this tab
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");

//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Salary Information & Payslips</h3>
//             </div>

//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE NAME</th>
//                     <th>UPLOADED ON</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-icon">📄</span>
//                           <div className="file-info">
//                             <span className="file-name">{slip.file_name}</span>
//                           </div>
//                         </td>
//                         <td className="month-cell">{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} download className="table-action-btn download">DOWNLOAD</a>
//                         </td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr><td colSpan="4" className="status-text">No payslips found in your record.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         // Filter: Show only "Annual Form 16" in this tab
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");

//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>CERTIFICATE FILE</th>
//                     <th>UPLOAD DATE</th>
//                     <th>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📄 {doc.file_name}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <a href={fileBaseUrl + doc.file_name} download className="table-action-btn download">DOWNLOAD PDF</a>
//                       </td>
//                     </tr>
//                   )) : (
//                     <tr><td colSpan="3" className="status-text">No Form 16 documents available.</td></tr>
//                   )}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       case "Reimburesemnt section":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>New Expense Claim</h3>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group locked"><label>Ticket</label><input className="form-input" value={reimburseData.ticketNum} readOnly /></div>
//                 <div className="form-group locked"><label>Employee</label><input className="form-input" value={userData?.FirstName + " " + userData?.LastName} readOnly /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Amount (₹)</label><input name="amount" type="number" className="form-input" onChange={handleInputChange} required /></div>
//                 <div className="form-group locked"><label>Dept</label><input className="form-input" value={userData?.Department} readOnly /></div>
//               </div>
//               <div className="form-group">
//                 <label>Receipt Attachment</label>
//                 <div className="file-upload-wrapper">
//                   <input type="file" id="file-upload" className="file-input-hidden" onChange={(e) => setReimburseData(prev => ({ ...prev, attachment: e.target.files[0] }))} />
//                   <label htmlFor="file-upload" className="file-upload-label">
//                     {reimburseData.attachment ? reimburseData.attachment.name : "Click to Upload Receipt"}
//                   </label>
//                 </div>
//               </div>
//               <button className="submit-leave-btn" onClick={() => alert("Reimbursement Submitted")}>SUBMIT CLAIM</button>
//             </form>
//           </div>
//         );

//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group">
//                     <label>Annual Gross CTC (₹)</label>
//                     <input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} />
//                   </div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" value={bankDetails.bankName} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <button className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           "Reimburesemnt section",
//           "Bonus & incentives",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.split(' ')[0].toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;




















// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData, employeeId }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);

//   // --- DATABASE STATES ---
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   // Base URL for your uploaded files on the PHP server
//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   // --- FETCH DOCUMENTS FROM REAL DATABASE ---
//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // Helper for formatting upload dates
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // --- BANK & REIMBURSEMENT STATE ---
//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.fullName || " ",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   // --- HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     switch (subView) {
//       case "Salary Information-payslip":
//         // Filter: Show only "Monthly Salary Slip" in this tab
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");

//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Salary Information & Payslips</h3>
//             </div>

//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE NAME</th>
//                     <th>UPLOADED ON</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-icon">📄</span>
//                           <div className="file-info">
//                             <span className="file-name">{slip.file_name}</span>
//                           </div>
//                         </td>
//                         <td className="month-cell">{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} download className="table-action-btn download">DOWNLOAD</a>
//                         </td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr><td colSpan="4" className="status-text">No payslips found in your record.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         // Filter: Show only "Annual Form 16" in this tab
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");

//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>CERTIFICATE FILE</th>
//                     <th>UPLOAD DATE</th>
//                     <th>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📄 {doc.file_name}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <a href={fileBaseUrl + doc.file_name} download className="table-action-btn download">DOWNLOAD PDF</a>
//                       </td>
//                     </tr>
//                   )) : (
//                     <tr><td colSpan="3" className="status-text">No Form 16 documents available.</td></tr>
//                   )}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       case "Reimburesemnt section":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>New Expense Claim</h3>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group locked"><label>Ticket</label><input className="form-input" value={reimburseData.ticketNum} readOnly /></div>
//                 <div className="form-group locked"><label>Employee</label><input className="form-input" value={userData?.FirstName + " " + userData?.LastName} readOnly /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Amount (₹)</label><input name="amount" type="number" className="form-input" onChange={handleInputChange} required /></div>
//                 <div className="form-group locked"><label>Dept</label><input className="form-input" value={userData?.Department} readOnly /></div>
//               </div>
//               <div className="form-group">
//                 <label>Receipt Attachment</label>
//                 <div className="file-upload-wrapper">
//                   <input type="file" id="file-upload" className="file-input-hidden" onChange={(e) => setReimburseData(prev => ({ ...prev, attachment: e.target.files[0] }))} />
//                   <label htmlFor="file-upload" className="file-upload-label">
//                     {reimburseData.attachment ? reimburseData.attachment.name : "Click to Upload Receipt"}
//                   </label>
//                 </div>
//               </div>
//               <button className="submit-leave-btn" onClick={() => alert("Reimbursement Submitted")}>SUBMIT CLAIM</button>
//             </form>
//           </div>
//         );

//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group">
//                     <label>Annual Gross CTC (₹)</label>
//                     <input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} />
//                   </div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" value={bankDetails.bankName} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <button className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           "Reimburesemnt section",
//           "Bonus & incentives",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.split(' ')[0].toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;





















// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);

//   // --- DATABASE STATES ---
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   // Base URL for your uploaded files on the PHP server
//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   // --- FETCH DOCUMENTS FROM REAL DATABASE ---
//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // Helper for formatting upload dates
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // --- BANK & REIMBURSEMENT STATE ---
//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.FirstName + " " + userData?.LastName || "",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   // --- HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   // FIX: Added clearBankForm to resolve ESLint error
//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.FirstName + " " + userData?.LastName || "",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };

//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     switch (subView) {
//       case "Salary Information-payslip":
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Salary Information & Payslips</h3>
//             </div>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE NAME</th>
//                     <th>UPLOADED ON</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-icon">📄</span>
//                           <div className="file-info">
//                             <span className="file-name">{slip.file_name}</span>
//                           </div>
//                         </td>
//                         <td className="month-cell">{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} download className="table-action-btn download">DOWNLOAD</a>
//                         </td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr><td colSpan="4" className="status-text">No payslips found in your record.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>CERTIFICATE FILE</th>
//                     <th>UPLOAD DATE</th>
//                     <th>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📄 {doc.file_name}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <a href={fileBaseUrl + doc.file_name} download className="table-action-btn download">DOWNLOAD PDF</a>
//                       </td>
//                     </tr>
//                   )) : (
//                     <tr><td colSpan="3" className="status-text">No Form 16 documents available.</td></tr>
//                   )}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );



//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group">
//                     <label>Annual Gross CTC (₹)</label>
//                     <input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} />
//                   </div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <div className="cyber-line" style={{marginBottom: '20px'}}></div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Bank Name</label>
//                   <input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Account Holder</label>
//                   <input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Account Number</label>
//                   <input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>IFSC Code</label>
//                   <input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Branch Name</label>
//                   <input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-actions" style={{display: 'flex', gap: '15px', marginTop: '10px'}}>
//                 <button type="button" className="submit-leave-btn" style={{background: '#64748b'}} onClick={clearBankForm}>CLEAR</button>
//                 <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button>
//               </div>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",

//           "Annual Performance",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.toUpperCase()}

//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };




// export default PayBenefits;












// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);

//   // --- DATABASE STATES ---
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   // Base URL for your uploaded files on the PHP server
//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   // --- FETCH DOCUMENTS FROM REAL DATABASE ---
//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // Helper for formatting upload dates
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   // --- BANK & REIMBURSEMENT STATE ---
//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.FirstName + " " + userData?.LastName || "",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   // --- HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.FirstName + " " + userData?.LastName || "",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };

//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     // 1. Appraisal Filter
//     const performanceDocs = dbDocuments.filter(d => d.doc_type === "APPRAISAL LETTER");

//     // 2. Miscellaneous Filter (Everything else that isn't Salary, Form 16, or Appraisal)
//     const miscDocs = dbDocuments.filter(d => 
//         !["Monthly Salary Slip", "Annual Form 16", "APPRAISAL LETTER"].includes(d.doc_type)
//     );

//     switch (subView) {
//       case "Salary Information-payslip":
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="card-header-flex">
//               <h3>Salary Information & Payslips</h3>
//             </div>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>FILE NAME</th>
//                     <th>UPLOADED ON</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-icon">📄</span>
//                           <div className="file-info">
//                             <span className="file-name">{slip.file_name}</span>
//                           </div>
//                         </td>
//                         <td className="month-cell">{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} download className="table-action-btn download">DOWNLOAD</a>
//                         </td>
//                         <td>
//                           <a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr><td colSpan="4" className="status-text">No payslips found in your record.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>CERTIFICATE FILE</th>
//                     <th>UPLOAD DATE</th>
//                     <th>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📄 {doc.file_name}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <a href={fileBaseUrl + doc.file_name} download className="table-action-btn download">DOWNLOAD PDF</a>
//                       </td>
//                     </tr>
//                   )) : (
//                     <tr><td colSpan="3" className="status-text">No Form 16 documents available.</td></tr>
//                   )}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       case "Annual Performance":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Performance & Appraisals</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT</th><th>DATE</th><th>ACTION</th></tr></thead>
//                         <tbody>
//                             {performanceDocs.length > 0 ? performanceDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📈 {doc.doc_type}</td>
//                                     <td>{formatDate(doc.upload_date)}</td>
//                                     <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                                 </tr>
//                             )) : <tr><td colSpan="3" className="status-text">No appraisal records found.</td></tr>}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       case "Miscellaneous Documents":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Miscellaneous Documents</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT TYPE</th><th>FILE NAME</th><th>ACTION</th></tr></thead>
//                         <tbody>
//                             {miscDocs.length > 0 ? miscDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📁 {doc.doc_type}</td>
//                                     <td>{doc.file_name}</td>
//                                     <td><a href={fileBaseUrl + doc.file_name} download className="table-action-btn download">DOWNLOAD</a></td>
//                                 </tr>
//                             )) : <tr><td colSpan="3" className="status-text">No miscellaneous documents found.</td></tr>}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group">
//                     <label>Annual Gross CTC (₹)</label>
//                     <input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} />
//                   </div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <div className="cyber-line" style={{marginBottom: '20px'}}></div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Bank Name</label>
//                   <input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Account Holder</label>
//                   <input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Account Number</label>
//                   <input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>IFSC Code</label>
//                   <input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Branch Name</label>
//                   <input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-actions" style={{display: 'flex', gap: '15px', marginTop: '10px'}}>
//                 <button type="button" className="submit-leave-btn" style={{background: '#64748b'}} onClick={clearBankForm}>CLEAR</button>
//                 <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button>
//               </div>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           "Annual Performance",
//           "Miscellaneous Documents",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;














// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // NEW: Force Download Function
//   const handleForceDownload = async (fileUrl, fileName) => {
//     try {
//       const response = await fetch(fileUrl);
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download failed", error);
//       // Fallback: try opening in new tab if fetch fails
//       window.open(fileUrl, '_blank');
//     }
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const getFormattedDocName = (doc) => {
//     if (doc.doc_type === "Monthly Salary Slip") {
//       const month = new Date(doc.upload_date).toLocaleString('default', { month: 'long' });
//       return `${month}_salary_slip`;
//     }
//     if (doc.doc_type === "Annual Form 16") {
//       return `Form_16`;
//     }
//     return doc.doc_type;
//   };

//   // ... (Keep your bankDetails, reimburseData, and calculateTax logic exactly as they are)

//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.FirstName + " " + userData?.LastName || "",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.FirstName + " " + userData?.LastName || "",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };



//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     const performanceDocs = dbDocuments.filter(d => d.doc_type === "APPRAISAL LETTER");
//     const miscDocs = dbDocuments.filter(d => 
//         !["Monthly Salary Slip", "Annual Form 16", "APPRAISAL LETTER"].includes(d.doc_type)
//     );

//     switch (subView) {
//       case "Salary Information-payslip":
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Salary Information & Payslips</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr><th>FILE NAME</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-name" style={{fontWeight: 'bold', color: '#00f2ff'}}>{getFormattedDocName(slip)}</span>
//                         </td>
//                         <td>{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <button 
//                             className="table-action-btn download" 
//                             onClick={() => handleForceDownload(fileBaseUrl + slip.file_name, getFormattedDocName(slip))}
//                           >
//                             DOWNLOAD
//                           </button>
//                         </td>
//                         <td><a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                       </tr>
//                     ))
//                   ) : (<tr><td colSpan="4">No payslips found.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead><tr><th>CERTIFICATE</th><th>UPLOAD DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell" style={{fontWeight: 'bold', color: '#00f2ff'}}>{getFormattedDocName(doc)}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <button 
//                           className="table-action-btn download" 
//                           onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, "Form_16")}
//                         >
//                           DOWNLOAD
//                         </button>
//                       </td>
//                       <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                     </tr>
//                   )) : (<tr><td colSpan="4">No Form 16 available.</td></tr>)}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       case "Annual Performance":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Performance & Appraisals</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT</th><th>DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                         <tbody>
//                             {performanceDocs.length > 0 ? performanceDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📈 {doc.doc_type}</td>
//                                     <td>{formatDate(doc.upload_date)}</td>
//                                     <td>
//                                       <button 
//                                         className="table-action-btn download" 
//                                         onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                                       >
//                                         DOWNLOAD
//                                       </button>
//                                     </td>
//                                     <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                                 </tr>
//                             )) : (<tr><td colSpan="4">No appraisal records found.</td></tr>)}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       case "Miscellaneous Documents":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Miscellaneous Documents</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT TYPE</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                         <tbody>
//                             {miscDocs.length > 0 ? miscDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📁 {doc.doc_type}</td>
//                                     <td>{formatDate(doc.upload_date)}</td>
//                                     <td>
//                                       <button 
//                                         className="table-action-btn download" 
//                                         onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                                       >
//                                         DOWNLOAD
//                                       </button>
//                                     </td>
//                                     <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                                 </tr>
//                             )) : (<tr><td colSpan="4">No miscellaneous documents found.</td></tr>)}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       // ... (Rest of your cases: Salary and tax calculator, Bank ACcount Information)
//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group"><label>Annual Gross CTC (₹)</label><input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} /></div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       case "Bank ACcount Information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <div className="cyber-line" style={{marginBottom: '20px'}}></div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Branch Name</label><input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-actions" style={{display: 'flex', gap: '15px', marginTop: '10px'}}>
//                 <button type="button" className="submit-leave-btn" style={{background: '#64748b'}} onClick={clearBankForm}>CLEAR</button>
//                 <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button>
//               </div>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           "Annual Performance",
//           "Miscellaneous Documents",
//           "Salary and tax calculator",
//           "Bank ACcount Information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;












// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // NEW: Force Download Function
//   const handleForceDownload = async (fileUrl, fileName) => {
//     try {
//       const response = await fetch(fileUrl);
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download failed", error);
//       // Fallback: try opening in new tab if fetch fails
//       window.open(fileUrl, '_blank');
//     }
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };



//   // const getFormattedDocName = (doc) => {
//   //   if (doc.doc_type === "Monthly Salary Slip") {
//   //     const month = new Date(doc.upload_date).toLocaleString('default', { month: 'long' });
//   //     return `${month}_salary_slip`;
//   //   }
//   //   if (doc.doc_type === "Annual Form 16") {
//   //     return `Form_16`;
//   //   }
//   //   return doc.doc_type;
//   // };

// const getFormattedDocName = (doc) => {
//   if (doc.doc_type === "Monthly Salary Slip" && doc.file_name) {
//     return doc.file_name.replace(".pdf", "");
//   }

//   if (doc.doc_type === "Annual Form 16") {
//     return "Form_16";
//   }

//   return doc.doc_type;
// };

//   // ... (Keep your bankDetails, reimburseData, and calculateTax logic exactly as they are)

//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.FirstName + " " + userData?.LastName || "",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.FirstName + " " + userData?.LastName || "",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };



//   const handleSaveBankDetails = async () => {
//   // Simple validation
//   if (!bankDetails.bankName || !bankDetails.accNumber) {
//     alert("Please fill in the Bank Name and Account Number.");
//     return;
//   }

//   try {
//     const response = await fetch("/gt-api/save_bank_details.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         emp_id: userData.id, // Ensure your userData has the id
//         ...bankDetails
//       }),
//     });

//     const data = await response.json();
//     if (data.success) {
//       alert("✅ Bank details updated successfully!");
//     } else {
//       alert("❌ Error: " + data.message);
//     }
//   } catch (err) {
//     console.error("Save Error:", err);
//     alert("Connection failed. Check if API is running.");
//   }
// };



//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     const performanceDocs = dbDocuments.filter(d => d.doc_type === "APPRAISAL LETTER");
//     const miscDocs = dbDocuments.filter(d => 
//         !["Monthly Salary Slip", "Annual Form 16", "APPRAISAL LETTER"].includes(d.doc_type)
//     );

//     switch (subView) {
//       case "Salary Information-payslip":
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Salary Information & Payslips</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr><th>FILE NAME</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="4" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (
//                     payslips.map((slip) => (
//                       <tr key={slip.id}>
//                         <td className="file-cell">
//                           <span className="file-name" style={{fontWeight: 'bold', color: '#00f2ff'}}>{getFormattedDocName(slip)}</span>
//                         </td>
//                         <td>{formatDate(slip.upload_date)}</td>
//                         <td>
//                           <button 
//                             className="table-action-btn download" 
//                             onClick={() => handleForceDownload(fileBaseUrl + slip.file_name, getFormattedDocName(slip))}
//                           >
//                             DOWNLOAD
//                           </button>
//                         </td>
//                         <td><a href={fileBaseUrl + slip.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                       </tr>
//                     ))
//                   ) : (<tr><td colSpan="4">No payslips found.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Form 16 Download":
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//                <table className="payslip-table">
//                 <thead><tr><th>CERTIFICATE</th><th>UPLOAD DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell" style={{fontWeight: 'bold', color: '#00f2ff'}}>{getFormattedDocName(doc)}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <button 
//                           className="table-action-btn download" 
//                           onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, "Form_16")}
//                         >
//                           DOWNLOAD
//                         </button>
//                       </td>
//                       <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                     </tr>
//                   )) : (<tr><td colSpan="4">No Form 16 available.</td></tr>)}
//                 </tbody>
//                </table>
//             </div>
//           </div>
//         );

//       case "Appraisal Letter":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Performance & Appraisals</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT</th><th>DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                         <tbody>
//                             {performanceDocs.length > 0 ? performanceDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📈 {doc.doc_type}</td>
//                                     <td>{formatDate(doc.upload_date)}</td>
//                                     <td>
//                                       <button 
//                                         className="table-action-btn download" 
//                                         onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                                       >
//                                         DOWNLOAD
//                                       </button>
//                                     </td>
//                                     <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                                 </tr>
//                             )) : (<tr><td colSpan="4">No appraisal records found.</td></tr>)}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       case "Miscellaneous Documents":
//         return (
//             <div className="pay-sub-card glass animate-fade">
//                 <h3>Miscellaneous Documents</h3>
//                 <div className="table-container" style={{ marginTop: '20px' }}>
//                     <table className="payslip-table">
//                         <thead><tr><th>DOCUMENT TYPE</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                         <tbody>
//                             {miscDocs.length > 0 ? miscDocs.map(doc => (
//                                 <tr key={doc.id}>
//                                     <td className="file-cell">📁 {doc.doc_type}</td>
//                                     <td>{formatDate(doc.upload_date)}</td>
//                                     <td>
//                                       <button 
//                                         className="table-action-btn download" 
//                                         onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                                       >
//                                         DOWNLOAD
//                                       </button>
//                                     </td>
//                                     <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                                 </tr>
//                             )) : (<tr><td colSpan="4">No miscellaneous documents found.</td></tr>)}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );

//       // ... (Rest of your cases: Salary and tax calculator, Bank ACcount Information)
//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group"><label>Annual Gross CTC (₹)</label><input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} /></div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       // case "Bank ACcount Information":
//       case "Update bank account information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <div className="cyber-line" style={{marginBottom: '20px'}}></div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Branch Name</label><input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-actions" style={{display: 'flex', gap: '15px', marginTop: '10px'}}>
//                 <button type="button" className="submit-leave-btn" style={{background: '#64748b'}} onClick={clearBankForm}>CLEAR</button>
//                 {/* <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button> */}
//                 <button type="button" className="submit-leave-btn" onClick={handleSaveBankDetails}>UPDATE INFORMATION</button>
//               </div>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           // "Annual Performance",
//           "Appraisal Letter",
//           "Miscellaneous Documents",
//           // "Salary and tax calculator",
//           // "Bank ACcount Information"
//           "Update bank account information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;













// import React, { useState, useEffect } from 'react';
// import '../styles/PayBenefits.css';

// const PayBenefits = ({ userData }) => {
//   const [subView, setSubView] = useState("Salary Information-payslip");
//   const [result, setResult] = useState(null);
//   const [dbDocuments, setDbDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   const fileBaseUrl = "/gt-api/uploads/salary_docs/";

//   useEffect(() => {
//     if (userData?.id) {
//       fetch(`/gt-api/get_my_documents.php?emp_id=${userData.id}`)
//         .then(res => res.json())
//         .then(data => {
//           if (data.success) {
//             setDbDocuments(data.documents);
//           }
//           setLoadingDocs(false);
//         })
//         .catch(err => {
//           console.error("Connection Error:", err);
//           setLoadingDocs(false);
//         });
//     }
//   }, [userData?.id]);

//   // NEW: Force Download Function
//   const handleForceDownload = async (fileUrl, fileName) => {
//     try {
//       const response = await fetch(fileUrl);
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download failed", error);
//       // Fallback: try opening in new tab if fetch fails
//       window.open(fileUrl, '_blank');
//     }
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };


//   const getSalaryMonth = (doc) => {
//     if (doc.file_name) {
//       const parts = doc.file_name.replace(".pdf", "").split("_");
//       if (parts.length >= 2) {
//         const month = parts[0];
//         const year = parts[1];

//         const formattedMonth =
//           month.charAt(0).toUpperCase() + month.slice(1);

//         return `${formattedMonth} ${year}`;
//       }
//     }
//     return formatDate(doc.upload_date);
//   };


//   // const getFormattedDocName = (doc) => {
//   //   if (doc.doc_type === "Monthly Salary Slip") {
//   //     const month = new Date(doc.upload_date).toLocaleString('default', { month: 'long' });
//   //     return `${month}_salary_slip`;
//   //   }
//   //   if (doc.doc_type === "Annual Form 16") {
//   //     return `Form_16`;
//   //   }
//   //   return doc.doc_type;
//   // };

//   const getFormattedDocName = (doc) => {
//     if (doc.doc_type === "Monthly Salary Slip" && doc.file_name) {
//       return doc.file_name.replace(".pdf", "");
//     }

//     if (doc.doc_type === "Annual Form 16") {
//       return "Form_16";
//     }

//     return doc.doc_type;
//   };

//   // ... (Keep your bankDetails, reimburseData, and calculateTax logic exactly as they are)

//   const [bankDetails, setBankDetails] = useState({
//     holderName: userData?.FirstName + " " + userData?.LastName || "",
//     bankName: "",
//     accNumber: "",
//     ifsc: "",
//     branch: "",
//     accType: "Saving Account"
//   });

//   const [reimburseData, setReimburseData] = useState({
//     ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
//     amount: '',
//     from: '',
//     to: '',
//     description: '',
//     attachment: null
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setReimburseData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setBankDetails(prev => ({ ...prev, [name]: value }));
//   };

//   const clearBankForm = () => {
//     setBankDetails({
//       holderName: userData?.FirstName + " " + userData?.LastName || "",
//       bankName: "",
//       accNumber: "",
//       ifsc: "",
//       branch: "",
//       accType: "Saving Account"
//     });
//   };



//   const handleSaveBankDetails = async () => {
//     // Simple validation
//     if (!bankDetails.bankName || !bankDetails.accNumber) {
//       alert("Please fill in the Bank Name and Account Number.");
//       return;
//     }

//     try {
//       const response = await fetch("/gt-api/save_bank_details.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           emp_id: userData.id, // Ensure your userData has the id
//           ...bankDetails
//         }),
//       });

//       const data = await response.json();
//       if (data.success) {
//         alert("✅ Bank details updated successfully!");
//       } else {
//         alert("❌ Error: " + data.message);
//       }
//     } catch (err) {
//       console.error("Save Error:", err);
//       alert("Connection failed. Check if API is running.");
//     }
//   };



//   const calculateTax = () => {
//     const gross = parseFloat(reimburseData.amount) || 0;
//     if (gross <= 0) {
//       alert("Please enter a valid CTC amount.");
//       return;
//     }
//     const standardDeduction = 75000;
//     const taxableIncome = Math.max(0, gross - standardDeduction);
//     let tax = 0;

//     if (taxableIncome > 700000) {
//       if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
//       else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
//       else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
//       else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
//       else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
//     }

//     const cess = tax * 0.04;
//     const totalTax = tax + cess;
//     const netAnnual = gross - totalTax;

//     setResult({
//       taxableIncome: taxableIncome.toLocaleString('en-IN'),
//       annualTax: totalTax.toLocaleString('en-IN'),
//       cess: cess.toLocaleString('en-IN'),
//       monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
//       annualPay: netAnnual.toLocaleString('en-IN')
//     });
//   };

//   const renderSubModule = () => {
//     const performanceDocs = dbDocuments.filter(d => d.doc_type === "APPRAISAL LETTER");
//     const miscDocs = dbDocuments.filter(d =>
//       !["Monthly Salary Slip", "Annual Form 16", "APPRAISAL LETTER"].includes(d.doc_type)
//     );

//     switch (subView) {
//       case "Salary Information-payslip":
//         const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Salary Information & Payslips</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead>
//                   <tr>
//                     <th>SR NO</th>
//                     <th>FILE NAME</th>
//                     <th>UPLOADED ON</th>
//                     <th>DOWNLOAD</th>
//                     <th>VIEW</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr><td colSpan="5" className="status-text">Synchronizing payroll data...</td></tr>
//                   ) : payslips.length > 0 ? (

//                     payslips.map((slip, index) => (
//                       <tr key={slip.id}>
//                         <td>{index + 1}</td>
//                         <td className="file-cell">
//                           <span className="file-name" style={{ fontWeight: 'bold', color: 'white' }}>
//                             {getFormattedDocName(slip)}
//                           </span>
//                         </td>

//                         <td>{getSalaryMonth(slip)}</td>

//                         <td>
//                           <button
//                             className="table-action-btn download"
//                             onClick={() => handleForceDownload(fileBaseUrl + slip.file_name, getFormattedDocName(slip))}
//                           >
//                             DOWNLOAD
//                           </button>
//                         </td>

//                         <td>

//                           <a
//                             href={`/gt-api/view_salary_doc.php?emp_id=${userData.id}&file=${slip.file_name}`}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="table-action-btn view"
//                           >
//                             VIEW
//                           </a>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (<tr><td colSpan="4">No payslips found.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>


//         );

//       case "Form 16 Download":
//         const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Form 16 Tax Certificates</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead><tr><th>CERTIFICATE</th><th>UPLOAD DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                 <tbody>
//                   {taxDocs.length > 0 ? taxDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell" style={{ fontWeight: 'bold', color: '#00f2ff' }}>{getFormattedDocName(doc)}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <button
//                           className="table-action-btn download"
//                           onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, "Form_16")}
//                         >
//                           DOWNLOAD
//                         </button>
//                       </td>
//                       <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                     </tr>
//                   )) : (<tr><td colSpan="4">No Form 16 available.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Appraisal Letter":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Performance & Appraisals</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead><tr><th>DOCUMENT</th><th>DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                 <tbody>
//                   {performanceDocs.length > 0 ? performanceDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📈 {doc.doc_type}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <button
//                           className="table-action-btn download"
//                           onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                         >
//                           DOWNLOAD
//                         </button>
//                       </td>
//                       <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
//                     </tr>
//                   )) : (<tr><td colSpan="4">No appraisal records found.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       case "Miscellaneous Documents":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Miscellaneous Documents</h3>
//             <div className="table-container" style={{ marginTop: '20px' }}>
//               <table className="payslip-table">
//                 <thead><tr><th>DOCUMENT TYPE</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
//                 <tbody>
//                   {miscDocs.length > 0 ? miscDocs.map(doc => (
//                     <tr key={doc.id}>
//                       <td className="file-cell">📁 {doc.doc_type}</td>
//                       <td>{formatDate(doc.upload_date)}</td>
//                       <td>
//                         <button
//                           className="table-action-btn download"
//                           onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
//                         >
//                           DOWNLOAD
//                         </button>
//                       </td>
//                       <td>
//                         <a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>

//                       </td>



//                     </tr>
//                   )) : (<tr><td colSpan="4">No miscellaneous documents found.</td></tr>)}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );

//       // ... (Rest of your cases: Salary and tax calculator, Bank ACcount Information)
//       case "Salary and tax calculator":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <div className="calculator-layout">
//               <div className="calc-inputs">
//                 <h3>Salary & Tax Calculator</h3>
//                 <div className="leave-form">
//                   <div className="form-group"><label>Annual Gross CTC (₹)</label><input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} /></div>
//                   <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
//                 </div>
//               </div>
//               <div className={`calc-results ${result ? 'active' : ''}`}>
//                 {result ? (
//                   <div className="result-content animate-slide-up">
//                     <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
//                     <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
//                     <div className="res-divider"></div>
//                     <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
//                   </div>
//                 ) : <div className="calc-placeholder">Awaiting Input...</div>}
//               </div>
//             </div>
//           </div>
//         );

//       // case "Bank ACcount Information":
//       case "Update bank account information":
//         return (
//           <div className="pay-sub-card glass animate-fade">
//             <h3>Bank Account Information</h3>
//             <div className="cyber-line" style={{ marginBottom: '20px' }}></div>
//             <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
//               <div className="form-row">
//                 <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group"><label>Branch Name</label><input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} /></div>
//                 <div className="form-group"><label>Account Type</label>
//                   <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
//                     <option value="Saving Account">Saving Account</option>
//                     <option value="Current Account">Current Account</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-actions" style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
//                 <button type="button" className="submit-leave-btn" style={{ background: '#64748b' }} onClick={clearBankForm}>CLEAR</button>
//                 {/* <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button> */}
//                 <button type="button" className="submit-leave-btn" onClick={handleSaveBankDetails}>UPDATE INFORMATION</button>
//               </div>
//             </form>
//           </div>
//         );

//       default:
//         return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {[
//           "Salary Information-payslip",
//           "Form 16 Download",
//           // "Annual Performance",
//           "Appraisal Letter",
//           "Miscellaneous Documents",
//           // "Salary and tax calculator",
//           // "Bank ACcount Information"
//           "Update bank account information"
//         ].map((tab) => (
//           <button
//             key={tab}
//             className={subView === tab ? 'active' : ''}
//             onClick={() => { setSubView(tab); setResult(null); }}
//           >
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">{renderSubModule()}</div>
//     </div>
//   );
// };

// export default PayBenefits;
























import React, { useState, useEffect } from 'react';
import '../styles/PayBenefits.css';

const PayBenefits = ({ userData }) => {
  const [subView, setSubView] = useState("Salary Information-payslip");
  const [result, setResult] = useState(null);
  const [dbDocuments, setDbDocuments] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(true);

  const fileBaseUrl = "/gt-api/uploads/salary_docs/";

  useEffect(() => {
    if (userData?.id) {
      fetch(
  `/gt-api/get_my_documents.php?emp_id=${userData.id}`,
  { credentials: "include" }
)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setDbDocuments(data.documents);
          }
          setLoadingDocs(false);
        })
        .catch(err => {
          console.error("Connection Error:", err);
          setLoadingDocs(false);
        });
    }
  }, [userData?.id]);

  // NEW: Force Download Function
  const handleForceDownload = async (fileUrl, fileName) => {
    try {
     const response = await fetch(fileUrl, {
  credentials: "include"
});
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
      // Fallback: try opening in new tab if fetch fails
      window.open(fileUrl, '_blank');
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };


  const getSalaryMonth = (doc) => {
    if (doc.file_name) {
      const parts = doc.file_name.replace(".pdf", "").split("_");
      if (parts.length >= 2) {
        const month = parts[0];
        const year = parts[1];

        const formattedMonth =
          month.charAt(0).toUpperCase() + month.slice(1);

        return `${formattedMonth} ${year}`;
      }
    }
    return formatDate(doc.upload_date);
  };



  const getFormattedDocName = (doc) => {
    if (doc.doc_type === "Monthly Salary Slip" && doc.file_name) {
      return doc.file_name.replace(".pdf", "");
    }

    if (doc.doc_type === "Annual Form 16") {
      return "Form_16";
    }

    return doc.doc_type;
  };


  const [bankDetails, setBankDetails] = useState({
    holderName: userData?.FirstName + " " + userData?.LastName || "",
    bankName: "",
    accNumber: "",
    ifsc: "",
    branch: "",
    accType: "Saving Account"
  });

  const [reimburseData, setReimburseData] = useState({
    ticketNum: `TKT-${Math.floor(1000 + Math.random() * 9000)}`,
    amount: '',
    from: '',
    to: '',
    description: '',
    attachment: null
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setReimburseData(prev => ({ ...prev, [name]: value }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setBankDetails(prev => ({ ...prev, [name]: value }));
  };

  const clearBankForm = () => {
    setBankDetails({
      holderName: userData?.FirstName + " " + userData?.LastName || "",
      bankName: "",
      accNumber: "",
      ifsc: "",
      branch: "",
      accType: "Saving Account"
    });
  };



  const handleSaveBankDetails = async () => {
    // Simple validation
    if (!bankDetails.bankName || !bankDetails.accNumber) {
      alert("Please fill in the Bank Name and Account Number.");
      return;
    }

    try {
      const response = await fetch("/gt-api/save_bank_details.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          emp_id: userData.id, // Ensure your userData has the id
          ...bankDetails
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert("✅ Bank details updated successfully!");
      } else {
        alert("❌ Error: " + data.message);
      }
    } catch (err) {
      console.error("Save Error:", err);
      alert("Connection failed. Check if API is running.");
    }
  };



  const calculateTax = () => {
    const gross = parseFloat(reimburseData.amount) || 0;
    if (gross <= 0) {
      alert("Please enter a valid CTC amount.");
      return;
    }
    const standardDeduction = 75000;
    const taxableIncome = Math.max(0, gross - standardDeduction);
    let tax = 0;

    if (taxableIncome > 700000) {
      if (taxableIncome > 1500000) tax += (taxableIncome - 1500000) * 0.30 + 150000;
      else if (taxableIncome > 1200000) tax += (taxableIncome - 1200000) * 0.20 + 90000;
      else if (taxableIncome > 1000000) tax += (taxableIncome - 1000000) * 0.15 + 60000;
      else if (taxableIncome > 700000) tax += (taxableIncome - 700000) * 0.10 + 30000;
      else if (taxableIncome > 300000) tax += (taxableIncome - 300000) * 0.05;
    }

    const cess = tax * 0.04;
    const totalTax = tax + cess;
    const netAnnual = gross - totalTax;

    setResult({
      taxableIncome: taxableIncome.toLocaleString('en-IN'),
      annualTax: totalTax.toLocaleString('en-IN'),
      cess: cess.toLocaleString('en-IN'),
      monthlyPay: (netAnnual / 12).toLocaleString('en-IN'),
      annualPay: netAnnual.toLocaleString('en-IN')
    });
  };

  const renderSubModule = () => {
    const performanceDocs = dbDocuments.filter(d => d.doc_type === "APPRAISAL LETTER");
    const miscDocs = dbDocuments.filter(d =>
      !["Monthly Salary Slip", "Annual Form 16", "APPRAISAL LETTER"].includes(d.doc_type)
    );

    switch (subView) {
      case "Salary Information-payslip":
        const payslips = dbDocuments.filter(d => d.doc_type === "Monthly Salary Slip");
        return (
          <div className="pay-sub-card glass animate-fade">
            <h3>Salary Information & Payslips</h3>
            <div className="table-container" style={{ marginTop: '20px' }}>
              <table className="payslip-table">
                <thead>
                  <tr>
                    <th>SR NO</th>
                    <th>FILE NAME</th>
                    <th>UPLOADED ON</th>
                    {/* <th>DOWNLOAD</th> */}
                    <th>VIEW & DOWNLOAD</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingDocs ? (
                    <tr><td colSpan="5" className="status-text">Synchronizing payroll data...</td></tr>
                  ) : payslips.length > 0 ? (

                    payslips.map((slip, index) => (
                      <tr key={slip.id}>
                        <td>{index + 1}</td>
                        <td className="file-cell">
                          <span className="file-name" style={{ fontWeight: 'bold', color: 'white' }}>
                            {getFormattedDocName(slip)}
                          </span>
                        </td>

                        <td>{getSalaryMonth(slip)}</td>

                        {/* <td>
                          <button
                            className="table-action-btn download"
                            onClick={() => handleForceDownload(fileBaseUrl + slip.file_name, getFormattedDocName(slip))}
                          >
                            DOWNLOAD
                          </button>
                        </td> */}

                        <td>

                          <a
                            href={`/gt-api/view_salary_doc.php?emp_id=${userData.id}&file=${slip.file_name}`}
                            target="_blank"
                            rel="noreferrer"
                            className="table-action-btn view"
                          >
                            VIEW & DOWNLOAD
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (<tr><td colSpan="4">No payslips found.</td></tr>)}
                </tbody>
              </table>
            </div>
          </div>


        );

      case "Form 16 Download":
        const taxDocs = dbDocuments.filter(d => d.doc_type === "Annual Form 16");
        return (
          <div className="pay-sub-card glass animate-fade">
            <h3>Form 16 Tax Certificates</h3>
            <div className="table-container" style={{ marginTop: '20px' }}>
              <table className="payslip-table">
                <thead><tr><th>CERTIFICATE</th><th>UPLOAD DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
                <tbody>
                  {taxDocs.length > 0 ? taxDocs.map(doc => (
                    <tr key={doc.id}>
                      <td className="file-cell" style={{ fontWeight: 'bold', color: '#00f2ff' }}>{getFormattedDocName(doc)}</td>
                      <td>{formatDate(doc.upload_date)}</td>
                      <td>
                        <button
                          className="table-action-btn download"
                          onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, "Form_16")}
                        >
                          DOWNLOAD
                        </button>
                      </td>
                      <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
                    </tr>
                  )) : (<tr><td colSpan="4">No Form 16 available.</td></tr>)}
                </tbody>
              </table>
            </div>
          </div>
        );

      case "Appraisal Letter":
        return (
          <div className="pay-sub-card glass animate-fade">
            <h3>Performance & Appraisals</h3>
            <div className="table-container" style={{ marginTop: '20px' }}>
              <table className="payslip-table">
                <thead><tr><th>DOCUMENT</th><th>DATE</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
                <tbody>
                  {performanceDocs.length > 0 ? performanceDocs.map(doc => (
                    <tr key={doc.id}>
                      <td className="file-cell">📈 {doc.doc_type}</td>
                      <td>{formatDate(doc.upload_date)}</td>
                      <td>
                        <button
                          className="table-action-btn download"
                          onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
                        >
                          DOWNLOAD
                        </button>
                      </td>
                      <td><a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a></td>
                    </tr>
                  )) : (<tr><td colSpan="4">No appraisal records found.</td></tr>)}
                </tbody>
              </table>
            </div>
          </div>
        );

      case "Miscellaneous Documents":
        return (
          <div className="pay-sub-card glass animate-fade">
            <h3>Miscellaneous Documents</h3>
            <div className="table-container" style={{ marginTop: '20px' }}>
              <table className="payslip-table">
                <thead><tr><th>DOCUMENT TYPE</th><th>UPLOADED ON</th><th>DOWNLOAD</th><th>VIEW</th></tr></thead>
                <tbody>
                  {miscDocs.length > 0 ? miscDocs.map(doc => (
                    <tr key={doc.id}>
                      <td className="file-cell">📁 {doc.doc_type}</td>
                      <td>{formatDate(doc.upload_date)}</td>
                      <td>
                        <button
                          className="table-action-btn download"
                          onClick={() => handleForceDownload(fileBaseUrl + doc.file_name, doc.doc_type)}
                        >
                          DOWNLOAD
                        </button>
                      </td>
                      <td>
                        <a href={fileBaseUrl + doc.file_name} target="_blank" rel="noreferrer" className="table-action-btn view">VIEW</a>

                      </td>



                    </tr>
                  )) : (<tr><td colSpan="4">No miscellaneous documents found.</td></tr>)}
                </tbody>
              </table>
            </div>
          </div>
        );

      // ... (Rest of your cases: Salary and tax calculator, Bank ACcount Information)
      case "Salary and tax calculator":
        return (
          <div className="pay-sub-card glass animate-fade">
            <div className="calculator-layout">
              <div className="calc-inputs">
                <h3>Salary & Tax Calculator</h3>
                <div className="leave-form">
                  <div className="form-group"><label>Annual Gross CTC (₹)</label><input type="number" name="amount" className="form-input" placeholder="e.g. 1200000" onChange={handleInputChange} /></div>
                  <button className="submit-leave-btn" onClick={calculateTax}>RUN ANALYSIS</button>
                </div>
              </div>
              <div className={`calc-results ${result ? 'active' : ''}`}>
                {result ? (
                  <div className="result-content animate-slide-up">
                    <div className="res-item"><span className="res-label">Taxable Income</span><span className="res-value">₹ {result.taxableIncome}</span></div>
                    <div className="res-item"><span className="res-label">Estimated Tax + Cess</span><span className="res-value neg">₹ {result.annualTax}</span></div>
                    <div className="res-divider"></div>
                    <div className="res-item main"><span className="res-label">Monthly Take Home</span><span className="res-value pos">₹ {result.monthlyPay}</span></div>
                  </div>
                ) : <div className="calc-placeholder">Awaiting Input...</div>}
              </div>
            </div>
          </div>
        );

      // case "Bank ACcount Information":
      case "Update bank account information":
        return (
          <div className="pay-sub-card glass animate-fade">
            <h3>Bank Account Information</h3>
            <div className="cyber-line" style={{ marginBottom: '20px' }}></div>
            <form className="leave-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-group"><label>Bank Name</label><input type="text" name="bankName" className="form-input" placeholder="e.g. HDFC Bank" value={bankDetails.bankName} onChange={handleBankChange} /></div>
                <div className="form-group"><label>Account Holder</label><input type="text" name="holderName" className="form-input" value={bankDetails.holderName} onChange={handleBankChange} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Account Number</label><input type="password" name="accNumber" className="form-input" placeholder="••••••••••••" value={bankDetails.accNumber} onChange={handleBankChange} /></div>
                <div className="form-group"><label>IFSC Code</label><input type="text" name="ifsc" className="form-input" placeholder="e.g. IFSC0001234" value={bankDetails.ifsc} onChange={handleBankChange} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Branch Name</label><input type="text" name="branch" className="form-input" value={bankDetails.branch} onChange={handleBankChange} /></div>
                <div className="form-group"><label>Account Type</label>
                  <select name="accType" className="form-input" value={bankDetails.accType} onChange={handleBankChange}>
                    <option value="Saving Account">Saving Account</option>
                    <option value="Current Account">Current Account</option>
                  </select>
                </div>
              </div>
              <div className="form-actions" style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                <button type="button" className="submit-leave-btn" style={{ background: '#64748b' }} onClick={clearBankForm}>CLEAR</button>
                {/* <button type="button" className="submit-leave-btn" onClick={() => alert("Bank Details Updated")}>UPDATE INFORMATION</button> */}
                <button type="button" className="submit-leave-btn" onClick={handleSaveBankDetails}>UPDATE INFORMATION</button>
              </div>
            </form>
          </div>
        );

      default:
        return <div className="pay-sub-card glass"><h3>{subView}</h3><p>Records loading...</p></div>;
    }
  };

  return (
    <div className="pay-module">
      <div className="pay-nav-grid">
        {[
          "Salary Information-payslip",
          "Form 16 Download",
          // "Annual Performance",
          "Appraisal Letter",
          "Miscellaneous Documents",
          // "Salary and tax calculator",
          // "Bank ACcount Information"
          "Update bank account information"
        ].map((tab) => (
          <button
            key={tab}
            className={subView === tab ? 'active' : ''}
            onClick={() => { setSubView(tab); setResult(null); }}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="pay-content-area">{renderSubModule()}</div>
    </div>
  );
};

export default PayBenefits;